module.exports = "<span\n    class=\"issue-status-component\"\n    ng-class=\"{\n        'Nowe':'new',\n        'Kosztorys': 'estimate',\n        'Przekazano':'forwarded',\n        'Przyjęto':'took',\n        'Częściowo zrealizowano':'partlyfixed',\n        'Zafakturowano':'fixed',\n        'Zrealizowano':'fixed',\n        'Nieaktualne':'stale',\n        'Odrzucono':'rejected'}[IssueStatusCtrl.status]\"\n>\n    {{ IssueStatusCtrl.status }}\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/parts/issue-status/issue-status.html
// module id = 683
// module chunks = 0